export default "__VITE_ASSET__BV6c1akV__"